import { useMediaQuery } from 'react-responsive';

export const IsDesktop = () => useMediaQuery({ query: '(min-width: 1224px)' });
export const IsTablet = () => useMediaQuery({ query: '(max-width: 768px)' });
